<template>
  <v-layout justify-center wrap>
    <!-- A loading spinner -->
    <v-flex v-if="loadingSimilarItems">
      <v-loading-message message="Cargando items similares" />
    </v-flex>
    <!-- The similar items grouped by productId -->
    <v-flex
      v-else-if="similarItems.length"
      v-for="(item, index) in filteredSimilarItems"
      :key="index"
      xs12
      sm4
      md3
      lg2
      class="pa-2"
    >
      <v-item-card comparison-dialog :item="item" qmp-cover-page selectable vertical xs />
    </v-flex>
    <!-- Show a message indicating that there are no items -->
    <v-flex
      v-else
      class="grey--text font-weight-light title my-5"
      shrink
    >Al parecer no items similares o que coincidan con los filtros.</v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import VItemCard from "../../components/ItemCard";
import VLoadingMessage from "../../components/LoadingMessage";

export default {
  components: {
    VItemCard,
    VLoadingMessage
  },
  computed: {
    ...mapGetters("matching", ["pivotItem", "filteredSimilarItems"]),
    ...mapState("matching", [
      "loadingSimilarItems",
      "similarItems",
      "similarItemsOrderBy"
    ]),
    brand() {
      return this.$route.params.brandName;
    },
    classificationId() {
      return this.$route.params.classificationId;
    }
  },
  watch: {
    pivotItem() {
      return this.getSimilarItems();
    },
    similarItemsOrderBy() {
      return this.getSimilarItems();
    }
  },
  created() {
    return this.getSimilarItems();
  },
  methods: {
    ...mapActions("matching", { getSimilarItemsAction: "getSimilarItems" }),
    getSimilarItems() {
      if (!this.pivotItem) return;
      this.getSimilarItemsAction({
        brand: this.brand,
        classificationId: this.classificationId,
        page: 1,
        sellerId: this.pivotItem.sellerId,
        historyId: this.pivotItem.historyId
      });
    }
  }
};
</script>
